const SYSTEM_FIELDS = new Set(['row_id', 'record_id', 'create_column', 'session_id']);

/** Collect display names from grid/API column descriptors, excluding system columns. */
export function getExistingColumnNames(columns = []) {
  const names = [];
  for (const column of columns) {
    const field = column.field || column.name;
    if (field && SYSTEM_FIELDS.has(field)) continue;
    const name = (column.columnName || column.headerName || column.name || '').trim();
    if (name) names.push(name);
  }
  return names;
}

/** Next unused name in the "Column N" sequence. */
export function generateDefaultColumnName(existingNamesOrColumns = []) {
  const names =
    existingNamesOrColumns.length > 0 && typeof existingNamesOrColumns[0] === 'object'
      ? getExistingColumnNames(existingNamesOrColumns)
      : existingNamesOrColumns.filter(Boolean);

  const reserved = new Set(names.map((n) => n.trim().toLowerCase()));
  let n = 1;
  while (reserved.has(`column ${n}`.toLowerCase())) {
    n += 1;
  }
  return `Column ${n}`;
}
